// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandedBox_root__3jS6V","titleDecoration":"BrandedBox_titleDecoration__QKh6C"};